import React, { useState, useEffect } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import Header from "../../component/header";
import Background from "../../component/background";
import TabbarOption from "../../component/tabbarOption";
import { FontAwesome } from "@expo/vector-icons";
import Modal from "modal-react-native-web";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/recoil";
import { apiservice } from "../../service";
import { styles, stylesResponsive } from "./style";
import moment from "moment";
import { sendmail, deleteComplete } from "../../action/authAction";
const { width, height } = Dimensions.get("window");
import { useIsFocused } from "@react-navigation/native";

export default function index({ navigation, error }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisible1, setModalVisible1] = useState(false);
  const [text, setText] = useState("");
  const [token, setToken] = useRecoilState(tokenState);
  const [competition, setCompetition] = useState([]);
  const isfocus = useIsFocused();
  const [caseNo, setCaseNo] = useState(3);

  async function onModalShow(state) {
    const resp = await sendmail({
      state: { competition_id: state.competition_id },
      token: token.token,
    });

    if (resp) {
      getAllcompe(token.token);
    }

    setModalVisible(true);
    setTimeout(() => {
      setModalVisible(false);
    }, 2000);
  }

  async function deleteCompleteApi(state) {
    console.log(state.competition_id, token.token);
    const resp = await deleteComplete({
      body: { competition_id: state.competition_id },
      token: token.token,
    });

    setModalVisible1(true);
    setTimeout(() => {
      getAllcompe(token.token);
      setModalVisible1(false);
    }, 2000);
  }

  useEffect(() => {
    getAllcompe(token.token);
  }, [token, isfocus]);

  async function getAllcompe(token) {
    try {
      const response = await apiservice({
        path: "/competitions/",
        method: "get",
        token: token,
      });
      setCompetition(response.data !== undefined && response.data.competitions);
    } catch (error) {
      throw error;
    }
  }

  console.log(competition);

  return (
    <View style={styles.container}>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModalVisible(!modalVisible);
        }}
      >
        <View style={{ flex: 1, backgroundColor: "#000000bb" }}>
          <View
            style={[
              styles.viewStatusMailModal,
              {
                width: width < 1280 ? width * 0.8 : width * 0.4,
                backgroundColor: error ? "#FFDEDE" : "#A7FFB2",
                borderColor: error ? "#B12B2B" : "#36FF5E",
              },
            ]}
          >
            <Text
              style={[
                styles.textStatusMailModal,
                {
                  fontSize: width < 1280 ? 22 : 28,
                  color: error ? "#B23131" : "#2BB165",
                },
              ]}
            >
              {error
                ? "E-MAIL NOT SEND. PLEASE TRY AGAIN"
                : "E-MAIL SEND SUCCESS"}
            </Text>
          </View>
        </View>
      </Modal>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible1}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModalVisible1(!modalVisible1);
        }}
      >
        <View style={{ flex: 1, backgroundColor: "#000000bb" }}>
          <View
            style={[
              styles.viewStatusMailModal,
              {
                width: width < 1280 ? width * 0.8 : width * 0.4,
                backgroundColor: "#FFDEDE",
                borderColor: "#B12B2B",
              },
            ]}
          >
            <Text
              style={[
                styles.textStatusMailModal,
                {
                  fontSize: width < 1280 ? 22 : 28,
                  color: "#B23131",
                },
              ]}
            >
              {error ? "E-MAIL NOT SEND. PLEASE TRY AGAIN" : "DELETE SUCCESS"}
            </Text>
          </View>
        </View>
      </Modal>
      <Header
        backgroundColorCompetition="#FFFFFF"
        Admin
        navigation={navigation}
      />
      <ScrollView>
        <View style={{}}>
          <Background navigation={navigation} Title="COMPETITIONS" admin />
          <TabbarOption
            onfilter={(e) => {
              setCaseNo(e);
              console.log(e);
            }}
            Competition
            buttonTabbar
            navigation={navigation}
            onChangeText={(text) => {
              setText(text);
            }}
          />
          {width >= 1280 && (
            <View style={styles.viewTopic}>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTopic : styles.textSubject,
                  { width: "100%", maxWidth: 120 },
                ]}
              >
                IMAGE
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTopic : styles.textSubject,
                  { textAlign: "left", width: "20%" },
                ]}
              >
                NAME
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTopic : styles.textSubject,
                  { width: "18%" },
                ]}
              ></Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTopic : styles.textSubject,
                  { width: "16%" },
                ]}
              >
                PRELIMINARY ENTRY DATE
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTopic : styles.textSubject,
                  { width: "16%" },
                ]}
              >
                FINAL ENTRY DATE
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTopic : styles.textSubject,
                  { width: "5%" },
                ]}
              >
                STATUS
              </Text>
              <Text
                numberOfLines={1}
                style={[
                  width < 1600 ? styles.textTopic : styles.textSubject,
                  { width: "10%" },
                ]}
              >
                SEND MAIL
              </Text>
            </View>
          )}
          <FlatList
            data={competition
              .filter((e) => {
                if (caseNo == "Active") {
                  return (
                    (e.prelim_status === "Open" &&
                      e.final_status === "Pending") ||
                    (e.prelim_status === "Closed" && e.final_status === "Open")
                  );
                } else if (caseNo == "Inactive") {
                  return (
                    !(
                      e.prelim_status === "Open" && e.final_status === "Pending"
                    ) ||
                    !(e.prelim_status === "Closed" && e.final_status === "Open")
                  );
                } else {
                  return e;
                }
              })
              .filter((item) =>
                item.name.toLowerCase().includes(text.toLowerCase())
              )}
            scrollEnabled={width < 1280 ? true : false}
            renderItem={({ index, item }) => {
              return width >= 1280 ? (
                <View
                  style={[
                    styles.viewDetail,
                    {
                      backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                    },
                  ]}
                >
                  <Image
                    resizeMode={"contain"}
                    style={styles.imgDetail}
                    source={{ uri: item.image_url }}
                  />
                  <Text
                    numberOfLines={1}
                    style={[width < 1600 ? styles.textName : styles.textTitle]}
                  >
                    {item.name}
                  </Text>
                  <View style={{ width: "18%" }}>
                    <View style={styles.viewButtonDetail}>
                      <TouchableOpacity
                        onPress={() => {
                          navigation.navigate("CompetitionEdit", item);
                        }}
                        style={[styles.buttomDetail]}
                      >
                        <Text
                          style={
                            width < 1600
                              ? stylesResponsive.textButtonDetail
                              : styles.textButtonDetail
                          }
                        >
                          EDIT
                        </Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => {
                          deleteCompleteApi(item);
                        }}
                        style={[styles.buttomDetail]}
                      >
                        <Text
                          style={
                            width < 1600
                              ? stylesResponsive.textButtonDetail
                              : styles.textButtonDetail
                          }
                        >
                          DELETE
                        </Text>
                      </TouchableOpacity>
                      <TouchableOpacity
                        onPress={() => {
                          navigation.navigate("CompetitionAthlete", item);
                        }}
                        style={styles.buttomDetail}
                      >
                        <Text
                          style={
                            width < 1600
                              ? stylesResponsive.textButtonDetail
                              : styles.textButtonDetail
                          }
                        >
                          ATHLETE
                        </Text>
                      </TouchableOpacity>
                    </View>
                    <TouchableOpacity
                      onPress={() => {
                        navigation.navigate("CompetitionStatus", item);
                      }}
                      style={[styles.buttomDetail, { width: "65%" }]}
                    >
                      <Text
                        style={
                          width < 1600
                            ? stylesResponsive.textButtonDetail
                            : styles.textButtonDetail
                        }
                      >
                        COUNTRIES STATUS
                      </Text>
                    </TouchableOpacity>
                  </View>
                  <View style={{ width: "16%" }}>
                    <Text
                      style={[
                        width < 1600 ? styles.textdate : styles.textSubject,
                        { width: "100%" },
                      ]}
                    >
                      {moment(item.prelim_start_date)
                        .utcOffset("+0000")
                        .format("DD/MM/YYYY HH:mm ") +
                        "(GMT" +
                        moment(item.prelim_start_date).format(" Z)") +
                        "\n-\n" +
                        moment(item.prelim_end_date)
                          .utcOffset("+0000")
                          .format("DD/MM/YYYY HH:mm ") +
                        "(GMT" +
                        moment(item.prelim_end_date).format(" Z)")}
                    </Text>
                  </View>
                  <View style={{ width: "16%" }}>
                    <Text
                      style={[
                        width < 1600 ? styles.textdate : styles.textSubject,
                        { width: "100%" },
                      ]}
                    >
                      {moment(item.final_start_date)
                        .utcOffset("+0000")
                        .format("DD/MM/YYYY HH:mm ") +
                        "(GMT" +
                        moment(item.final_start_date).format(" Z)") +
                        "\n-\n" +
                        moment(item.final_end_date)
                          .utcOffset("+0000")
                          .format("DD/MM/YYYY HH:mm ") +
                        "(GMT" +
                        moment(item.final_end_date).format(" Z)")}
                    </Text>
                  </View>
                  <Text
                    style={[
                      width < 1600 ? styles.textdate : styles.textSubject,
                      { width: "5%" },
                    ]}
                  >
                    {item.prelim_status === "Open" ||
                    item.final_status === "Open"
                      ? "active"
                      : "inactive"}
                  </Text>
                  <View style={{ width: "10%", alignItems: "center" }}>
                    <TouchableOpacity
                      onPress={() => onModalShow(item)}
                      style={[styles.buttomSendMail, { alignSelf: "center" }]}
                    >
                      <Text
                        style={
                          width < 1600
                            ? styles.textButtonDetailRespons
                            : styles.textButtonDetail
                        }
                      >
                        SEND MAIL ALL
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              ) : (
                <View
                  style={[
                    stylesResponsive.viewDetail,
                    {
                      borderTopWidth: index >= 1 ? 0 : 1,
                      backgroundColor: index % 2 == 0 ? "#CCE4FF" : "#FFFFFFbb",
                    },
                  ]}
                >
                  <View style={{ width: "40%" }}>
                    <Image
                      resizeMode={"contain"}
                      style={stylesResponsive.imgDetail}
                      source={{ uri: item.image_url }}
                    />
                  </View>
                  <View>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textTitle]}
                    >
                      {item.name}
                    </Text>
                    <View style={{}}>
                      <View style={stylesResponsive.viewButtonDetail}>
                        <TouchableOpacity
                          onPress={() => {
                            navigation.navigate("CompetitionEdit", item);
                          }}
                          style={[styles.buttomDetail]}
                        >
                          <Text style={stylesResponsive.textButtonDetail}>
                            EDIT
                          </Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          onPress={() => {
                            deleteCompleteApi(item);
                          }}
                          style={[styles.buttomDetail]}
                        >
                          <Text style={stylesResponsive.textButtonDetail}>
                            DELETE
                          </Text>
                        </TouchableOpacity>
                        <TouchableOpacity
                          onPress={() => {
                            navigation.navigate("CompetitionAthlete", item);
                          }}
                          style={styles.buttomDetail}
                        >
                          <Text style={stylesResponsive.textButtonDetail}>
                            ATHLETE
                          </Text>
                        </TouchableOpacity>
                      </View>
                      <TouchableOpacity
                        onPress={() => {
                          navigation.navigate("CompetitionStatus", item);
                        }}
                        style={[styles.buttomDetail, { width: "65%" }]}
                      >
                        <Text style={stylesResponsive.textButtonDetail}>
                          COUNTRIES STATUS
                        </Text>
                      </TouchableOpacity>
                    </View>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textTitle]}
                    >
                      PRELIMINARY ENTRY DATE
                    </Text>
                    <Text style={[stylesResponsive.textSubject]}>
                      {moment(item.prelim_start_date)
                        .utcOffset("+0000")
                        .format("DD/MM/YYYY HH:mm ") +
                        "(GMT" +
                        moment(item.prelim_start_date).format(" Z)") +
                        "\n-\n" +
                        moment(item.prelim_end_date)
                          .utcOffset("+0000")
                          .format("DD/MM/YYYY HH:mm ") +
                        "(GMT" +
                        moment(item.prelim_end_date).format(" Z)")}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textTitle]}
                    >
                      FINAL ENTRY DATE
                    </Text>
                    <Text style={[stylesResponsive.textSubject]}>
                      {moment(item.final_start_date)
                        .utcOffset("+0000")
                        .format("DD/MM/YYYY HH:mm ") +
                        "(GMT" +
                        moment(item.final_start_date).format(" Z)") +
                        "\n-\n" +
                        moment(item.final_end_date)
                          .utcOffset("+0000")
                          .format("DD/MM/YYYY HH:mm ") +
                        "(GMT" +
                        moment(item.final_end_date).format(" Z)")}
                    </Text>
                    <Text
                      numberOfLines={1}
                      style={[stylesResponsive.textTitle]}
                    >
                      STATUS
                    </Text>
                    <Text style={[stylesResponsive.textSubject]}>
                      {item.final_status}
                    </Text>

                    <View style={{ alignItems: "center", marginVertical: 10 }}>
                      <TouchableOpacity
                        onPress={() => onModalShow(item)}
                        style={[
                          styles.buttomSendMail,
                          {
                            alignSelf: width >= 1280 ? "center" : "flex-start",
                          },
                        ]}
                      >
                        <Text style={styles.textButtonDetail}>
                          SEND MAIL ALL
                        </Text>
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              );
            }}
          />
        </View>
      </ScrollView>
    </View>
  );
}
